import React, { ReactNode } from 'react';
import { MenuItemProps } from '@mui/material';

import { useAmountOutdated } from 'hooks/useAmountOutdated';
import MenuItem from '../../styled/MenuItem';

interface MenuItemWrapperProps extends MenuItemProps {
  children: ReactNode;
  agreementId: string | number;
}

export const MenuItemWrapper = ({
  children,
  agreementId,
  ...props
}: MenuItemWrapperProps) => {
  const amountOutdated = useAmountOutdated(Number(agreementId));

  if (amountOutdated) {
    return null;
  }

  return <MenuItem {...props}>{children}</MenuItem>;
};
